import React from 'react';
import { Link } from 'react-router-dom';
import MediumshipLogo from '../components/MediumshipLogo';
import './Home.css';

const FEATURES = [
  {
    title: 'Booking & scheduling',
    body: "Clients book sessions against a practitioner's live availability, which stays in sync with their connected Google Calendar so double-bookings never happen."
  },
  {
    title: 'Billing & invoicing',
    body: 'Secure payments, invoices, and coupon codes are handled automatically once a session is booked, so practitioners get paid without the back-and-forth.'
  },
  {
    title: 'Client CRM & campaigns',
    body: 'Practitioners keep a history of every client relationship and can send email campaigns and reports, all from one dashboard.'
  },
  {
    title: 'Video sessions',
    body: 'Confirmed bookings get a Google Meet link automatically, with optional recording for practitioners who offer it.'
  }
];

function Home() {
  return (
    <div className="home-page">
      <header className="home-header">
        <MediumshipLogo variant="horizontal" size={32} />
        <nav className="home-nav">
          <Link to="/login" className="btn btn-ghost btn-sm">Log In</Link>
          <Link to="/register" className="btn btn-primary btn-sm">Get Started</Link>
        </nav>
      </header>

      <main>
        <section className="home-hero">
          <h1>Booking, billing & CRM for mediumship practitioners</h1>
          <p className="home-subtitle">
            Had Mediumship is a booking platform built for mediums and intuitive practitioners. Clients
            schedule and pay for sessions online; practitioners manage their availability, invoices, client
            relationships, and video sessions from a single dashboard.
          </p>
          <div className="home-cta">
            <Link to="/register" className="btn btn-primary">Get Started</Link>
            <Link to="/login" className="btn btn-secondary">Log In</Link>
          </div>
        </section>

        <section className="home-features">
          {FEATURES.map((f) => (
            <div className="card home-feature" key={f.title}>
              <h3>{f.title}</h3>
              <p>{f.body}</p>
            </div>
          ))}
        </section>
      </main>

      <footer className="home-footer">
        <span>&copy; {new Date().getFullYear()} Had Collective, LLC</span>
        <div className="home-footer-links">
          <Link to="/legal/privacy">Privacy Policy</Link>
          <Link to="/legal/terms">Terms &amp; Conditions</Link>
        </div>
      </footer>
    </div>
  );
}

export default Home;
